import './helpers/compatibility.js';
import Form from './components/Form/Form.html';

/* Contact Form */
let form = new Form({
    target: document.getElementById('form'),
});

form.on('submit', ({ data }) => {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
        return;
    }

    window.dataLayer.push({
        'event':'landingpageFormSubmission',
        'landingpageFormData': {
            'email': data.email,
        },
    });
});

/* Sticky CTA Bar */
window.addEventListener('load', () => {
    const CTA_BAR_CLASS = 'c-cta-bar';
    const CTA_BAR_STICKY_CLASS = 'c-cta-bar--sticky';
    const CTA_BAR_STICKY_WHITESPACE = 36;

    let wrapper = document.querySelector('.c-layout-landingpage__cta');
    let cta = wrapper.querySelector(`.${CTA_BAR_CLASS}`);

    let scrollHandler = window.addEventListener('scroll', () => {
        let bottom = wrapper.getBoundingClientRect().bottom;
        let screenHeight = window.innerHeight;

        window.requestAnimationFrame(() => {
            if(bottom - screenHeight > -1 * CTA_BAR_STICKY_WHITESPACE) {
                cta.classList.add(CTA_BAR_STICKY_CLASS);
            } else {
                cta.classList.remove(CTA_BAR_STICKY_CLASS);
            }
        });
    });

    window.scrollTo(window.scrollX, window.scrollY - 1);
    window.scrollTo(window.scrollX, window.scrollY + 1);
});
